import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import Dropdown from '../Dropdown';
import RightMenu from '../RightMenu';
import CalendarButton from '../CalendarButton';
import RightIconMenu from "../RightIconMenu";

import "./index.css";
// import BasicSoundPlayer  from '../../Elements/AWSSoundPlayer';
export default class View_type_18 extends Component {
	constructor(props) {
		super(props);
		console.log("View_type_13 ", props);
		var data = {list:[], title:'', calendar:[], right_menu:[], prev_dropdown:[], tabs:[], ...props.data};

		this.state = {
			data: data,
			r_menu: data.right_menu ? data.right_menu : [],
			title: data.title ? data.title : "",
			tabs: data.tabs ? props.data.tabs : [],
			content: data.content ? data.content : [],
			read_more: data.read_more ? data.read_more : [],
			list: data.list ? data.list : [],
			content_title: data.content_title ? data.content_title : null,
			prevDropdown: data.prev_dropdown?data.prev_dropdown:'',
			calendar: data.calendar ? data.calendar:'',
			rightMenu: data.right_menu,
			tabs: data.tabs,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

		};
		// console.log('ADUO',this.state.audio);
	}

	createMarkup(item) {
		return { __html: item };
	}



	render() {
		//console.log("multimedia test", this.props.data.multimedia);
		const {
			description,
			title_image,
			table,
			pagination,
			border_bottom
		} = this.props.data;
		var _this = this;
		var var1 = this.state.data.title ? this.state.data.title : "";

		var calendar = this.state.calendar ? (
			<Link to={this.state.calendar.url}>
				<div className="vt2-calendar">
					<img className="vt2-calendar-img" src={this.state.calendar.img} />
					{this.state.calendar.text}
				</div>
			</Link>
		) : null;
		let flex = null;
		if (this.props.data.list[0].cols) {
			flex = {
				display: "flex",
				flexWrap: "wrap"
			};
		}
		let borderBottomClass = null;
		if (border_bottom) {
			borderBottomClass = {
				borderBottom: "2px solid #c1c1c1"
			};
		}
		return (
			<div className="vt2">
				<div className="vt2 left col-xs-12 col-sm-12 col-md-8 col-lg-9">
					<div className="vt2 row">
						<div className="vt2-title vt13-title">
							{this.props.data.border_bottom ? (
								<div
									style={borderBottomClass}
									className="vt2-title-name vt14-title-name artists-pageTitle"
									dangerouslySetInnerHTML={{ __html: var1 }}
								/>
							) : (
								<div
									className="vt2-title-name vt14-title-name artists-pageTitle"
									dangerouslySetInnerHTML={{ __html: var1 }}
								/>
							)}

							{this.props.data.single_list_content ? (
								<div>
									<div>
										<h2 className="single_list_title">Do Augsta Frachomme w Le cote lorem!</h2>
										<p>Lorem Ipsum Dolor Lorem loerm lorem 122 [12.wrzesien 1883]</p>
									</div>
									<div className="single_list_head-line">
										<span><strong>Nadawca</strong></span>
										<p>Frydryk Chopin Lorem lorem</p>
									</div>
									<div className="single_list_head-line">
										<span><strong>Adresat</strong></span>
										<p> Franchomme August Lorem lorem</p>
									</div>
									<div className="single_list_head-line">
										<span>[Tłuymaczenie]</span>
										<p>Sed nec elit consectetur, suscipit ligula id, pharetra orci. Phasellus molestie euismod elit, eget eleifend arcu vestibulum et. Etiam condimentum leo sit amet neque consequat, ac imperdiet erat mollis. Sed laoreet sollicitudin ipsum eget dictum. Sed auctor massa in eleifend suscipit. Cras imperdiet arcu libero, vel fermentum diam gravida ac. Nulla sagittis diam ac condimentum aliquet. Aenean vitae lobortis massa. Quisque quis pulvinar elit, eu sagittis orci. Fusce vitae mollis erat. Vivamus et semper ligula. Duis scelerisque orci congue lacinia pellentesque. Sed viverra non sapien mollis sodales. Mauris volutpat, orci vel facilisis volutpat, urna tortor ultricies justo, at malesuada elit libero non tellus. Pellentesque neque justo, molestie malesuada efficitur non, laoreet viverra turpis.</p>
									</div>
									<div className="single_list_head-line">
										<span>Oryginal</span>
										<p>Sed nec elit consectetur, suscipit ligula id, pharetra orci. Phasellus molestie euismod elit, eget eleifend arcu vestibulum et. Etiam condimentum leo sit amet neque consequat, ac imperdiet erat mollis. Sed laoreet sollicitudin ipsum eget dictum. Sed auctor massa in eleifend suscipit. Cras imperdiet arcu libero, vel fermentum diam gravida ac. Nulla sagittis diam ac condimentum aliquet. Aenean vitae lobortis massa. Quisque quis pulvinar elit, eu sagittis orci. Fusce vitae mollis erat. Vivamus et semper ligula. Duis scelerisque orci congue lacinia pellentesque. Sed viverra non sapien mollis sodales. Mauris volutpat, orci vel facilisis volutpat, urna tortor ultricies justo, at malesuada elit libero non tellus. Pellentesque neque justo, molestie malesuada efficitur non, laoreet viverra turpis.</p>
									</div>
									<div className="single_list_head-line">
										<span>Oryginal CD </span>
										<p>Sed nec elit consectetur, suscipit ligula id, pharetra orci. Phasellus molestie euismod elit, eget eleifend arcu vestibulum et. Etiam condimentum leo sit amet neque consequat, ac imperdiet erat mollis. Sed laoreet sollicitudin ipsum eget dictum. Sed auctor massa in eleifend suscipit. Cras imperdiet arcu libero, vel fermentum diam gravida ac. Nulla sagittis diam ac condimentum aliquet. Aenean vitae lobortis massa. Quisque quis pulvinar elit, eu sagittis orci. Fusce vitae mollis erat. Vivamus et semper ligula. Duis scelerisque orci congue lacinia pellentesque. Sed viverra non sapien mollis sodales. Mauris volutpat, orci vel facilisis volutpat, urna tortor ultricies justo, at malesuada elit libero non tellus. Pellentesque neque justo, molestie malesuada efficitur non, laoreet viverra turpis.</p>
									</div>
								</div>
							) : null}

							{title_image && (
								<div className="vt14 title_image">
									{this.props.data.title_description && (
										<h2 className="vt14 title-image__description">
											{this.props.data.title_description}
										</h2>
									)}
									<img src={title_image} />
								</div>
							)}
							{this.props.data.schedule && (
								<div className="vt14 schedule">
									{this.props.data.starting_page ? (
										<div
											className=""
											dangerouslySetInnerHTML={_this.createMarkup(description)}
										/>
									) : (
										<div
											className="vt2_chopin_list__description"
											dangerouslySetInnerHTML={_this.createMarkup(description)}
										/>
									)}

									{this.props.data.schedule.map((elem, key) => {
										return (
											<div className="row vt14 schedule__wrapper" key={key}>
												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Gatunek:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.genre}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Tonacja:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.mood}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Opus:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.opus}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Data Powstania:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.date_start}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Wg Paderewskiego:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.wg_paderewskiego}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Wg Turb:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.wg_turbo}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Obsada:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.cast}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Utwór dedytkowany:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.dedicated}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Zródla rękopismienne:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
													{" "}
													{elem.sources}
												</div>

												<div className="col-sm-5 col-xs-12 vt14 schedule__border">
													{" "}
													Pierwodruki:
												</div>
												<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right schedule__border--pierwodruki">
													{" "}
													<span
														style={{
															display: "block"
														}}
													>
														{elem.editions}
													</span>
													<span
														style={{
															display: "block"
														}}
													>
														{elem.editions}
													</span>
													<span
														style={{
															display: "block"
														}}
													>
														{elem.editions}
													</span>
												</div>
											</div>
										);
									})}
								</div>
							)}
							{table && (
								<div className="row vt14 table-container">
									{table.map((elem, key) => {
										return (
											<div key={key} className={`col-sm-12 col-md-4 vt14 table-row table-box${key}`}>
												{elem.name_multi}
												<hr />
											</div>
										);
									})}
								</div>
							)}
							<h2 className="vt14-content__title">
								{this.state.content_title}
							</h2>
							{!this.state.data.schedule && (
								<div
									className=""
									style={{
										marginBottom: "25px"
									}}
									dangerouslySetInnerHTML={_this.createMarkup(description)}
								/>
							)}

							<div className="vt2-title-tabs">
								{this.state.tabs.map(function(object, i) {
									if (object.active === 1) {
										return (
											<div
												className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
												key={i}
											>
												<div className="vt2 tab-checked">
													<Link to={"/" + object.link}>{object.title}</Link>
												</div>
											</div>
										);
									} else {
										return (
											<div
												className="vt2 col-xs-6 col-sm-6 col-md-6 col-lg-6"
												key={i}
											>
												<Link to={"/" + object.link}>{object.title}</Link>
											</div>
										);
									}
								})}
							</div>
						</div>
						<div className="vt2-content">
							<div
								dangerouslySetInnerHTML={_this.createMarkup(this.state.content)}
							/>
						</div>
						<div>
							{!this.props.data.content &&
							!this.props.data.single_list_content ? (
								<div style={flex}>
									{" "}
									{this.state.data.list.map(function(object, i) {
										//console.log("tlo", object.img);
										if (object.cols == 3) {
											var color = "rgba(0,156,178,0.5)";

											if (
												object !== "undefined" &&
												object.hasOwnProperty("img") &&
												!object.hasOwnProperty("text")
											) {
												var img = object.img;
												var thumbnail = (
													<div
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white",
															position: "absolute",
															left: 15,
															right: 15
														}}
													>
														{object.title}
													</div>
												);
												return (
													<div
														className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
														key={i}
													>
														<div>
															{thumbnail}
															<img src={img} className="vt2 list_image" />
														</div>
													</div>
												);
											} else if (object !== "undefined") {
												var button = null;
												var img = object.img;
												var thumbnail = (
													<div
														className="vt2 middle-thumbnailholder"
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white"
														}}
													>
														{object.title}
													</div>
												);
												var img = (
													<div>
														<img src={img} />
													</div>
												);

												if (typeof object.button !== "undefined") {
													button = (
														<div className="vt2 middle-addelem">
															<Link
																to={object.button.link}
																className="vt2 more_button"
															>
																{" "}
															</Link>
														</div>
													);
												}

												if (i == 0) {
													return (
														<div
															className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
															key={i}
														>
															<div className="vt2 row">
																<div
																	className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box"
																	// style={{
																	// 	backgroundImage: `url(${object.img})`,
																	// 	height: "150px"
																	// }}
																>
																	{img}

																</div>
																<div>
																	<Link to={object.button.link}>
																		<div
																			className="ChopinLists__text-button"
																			dangerouslySetInnerHTML={_this.createMarkup(
																				object.text
																			)}
																		/>
																	</Link>
																	{button}

																	<div
																		className="ChopinLists__sub-title"
																		dangerouslySetInnerHTML={_this.createMarkup(
																			object.sub_title
																		)}
																	/>
																</div>
															</div>
														</div>
													);
												} else {
													return (
														<div
															className="vt2-col vt2-col--playlist col-xs-6 col-sm-4 col-md-4 col-lg-4 text-center"
															key={i}
														>
															<div className="vt2 row">
																<div
																	className="vt2 middle-postblock middle-postblock--box ChopinLists__middle-postblock--box"
																	// style={{
																	// 	height: "150px",
																	// 	background: `url(${object.img})`
																	// }}
																>
																	{img}
																</div>
																<div>
																	<Link to={object.button.link}>
																		<div
																			className="ChopinLists__text-button"
																			dangerouslySetInnerHTML={_this.createMarkup(
																				object.text
																			)}
																		/>
																	</Link>
																	{button}

																	<div
																		className="ChopinLists__sub-title"
																		dangerouslySetInnerHTML={_this.createMarkup(
																			object.sub_title
																		)}
																	/>
																</div>
															</div>
														</div>
													);
												}
											}
										} else {
											var color = "rgba(0,156,178,0.5)";

											if (
												object !== "undefined" &&
												object.hasOwnProperty("img") &&
												!object.hasOwnProperty("text")
											) {
												var img = object.img;
												var thumbnail = (
													<div
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white",
															position: "absolute",
															left: 15,
															right: 15
														}}
													>
														{object.title}
													</div>
												);
												return (
													<div
														className="vt2 col-xs-12 col-sm-12 col-md-12 col-lg-12"
														key={i}
													>
														<div>
															{thumbnail}
															<img src={img} className="vt2 list_image" />
														</div>
													</div>
												);
											} else if (object !== "undefined") {
												var button = null;
												var img = object.img;
												var thumbnail = (
													<div
														className="vt2 middle-thumbnailholder"
														style={{
															flex: 1,
															backgroundColor: color,
															padding: 10,
															color: "white"
														}}
													>
														{object.title}
													</div>
												);
												var img = (
													<div>
														<img src={img} />
													</div>
												);

												if (typeof object.button !== "undefined") {
													button = (
														<div className="vt2 middle-addelem">
															<Link
																to={object.button.link}
																className="vt2 more_button"
															>
																{" "}
															</Link>
														</div>
													);
												}

												if (i == 0) {
													return (
														<div
															className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
															key={i}
														>
															<div className="vt2 middle-postblock">
																{img}
																<p className="vt3 vt13 middlepost-titleitem ">
																	{object.title}
																</p>
																<div
																	dangerouslySetInnerHTML={_this.createMarkup(
																		object.text
																	)}
																/>
																{button}
															</div>
														</div>
													);
												} else {
													return (
														<div
															className="vt2-col col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center"
															key={i}
														>
															<div className="vt2 middle-postblock">
																{img}
																<p className="vt3 vt13 middlepost-titleitem ">
																	{object.title}
																</p>

																<div
																	dangerouslySetInnerHTML={_this.createMarkup(
																		object.text
																	)}
																/>
																{button}
															</div>
														</div>
													);
												}
											}
										}
									})}
								</div>
							) : null}
						</div>
					</div>
				</div>
				<div className="vt5 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
					{this.state.calendar.length ? <CalendarButton data={this.state.calendar} /> : null}
					{this.state.prevDropdown.length || Object.keys(this.state.prevDropdown).length ? <Dropdown data={this.state.prevDropdown} /> : null}
					{this.state.rightMenu.length ? <RightMenu data={this.state.rightMenu} /> : null}
					{this.state.rightIconMenu &&
						<RightIconMenu data={this.state.rightIconMenu}/>
					}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_18/index.js